import * as React from 'react';
import {Provider} from 'react-redux';
import {IndividualSurveysDashboard} from './IndividualSurveysDashboard';
import {store} from './store';

export const IndividualSurveysDashboardContainer = () => {
  return (
    <Provider store={store}>
      <IndividualSurveysDashboard />
    </Provider>
  )
};
